module.exports = __webpack_public_path__ + "928d5b9a17a5dc686dfeb8acfa4ea35e.png";